import * as React from 'react';
import {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import {BASE_URL, BUSINESS} from "../constants";
import {reportErrors} from "../helpers";
import {Card, Grid} from "@mui/material";
import DashboardCard from "../components/DashboardCard";
import Divider from "@mui/material/Divider";
import Chart from "react-apexcharts";
import Typography from "@mui/material/Typography";
import SelectField from "../components/SelectField";
export default function DashboardPage(props) {
    const [data, setData] = useState({});
    const [businessType, setBusinessType] = useState(window.$user?.company?.businessType);

    useEffect(() => {
        loadData();
    }, [businessType]);
    const loadData = () => {
        let url = `${BASE_URL}api/dashboard?data=data`;
        if (businessType) {
            url += `&businessType=${businessType}`;
        }

        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}><Typography variant="h5">Dashboard</Typography></Grid>
                <Grid item xs={12}><Divider/></Grid>
                <Grid item xs={12}>
                    <SelectField
                        required={true}
                        placeholder="Business Type"
                        options={BUSINESS}
                        value={businessType}
                        onChange={(value) => setBusinessType(value)}
                    />
                </Grid>
                <Grid item xs={4}>
                    <DashboardCard title={"Feedback Question"} description={data?.feedBackQuestion}/>
                </Grid>
                <Grid item xs={4}>
                    <DashboardCard title={"Number of Response"} description={data?.response}/>
                </Grid>
                <Grid item xs={4}>
                    <DashboardCard title={"Total Comments"} description={data?.comments}/>
                </Grid>
                <Grid item xs={12}><Divider/></Grid>
                <Grid item xs={4}>
                    <Card>
                        <Chart
                            options={{
                                chart: {
                                    id: "basic-bar"
                                },
                                xaxis: {
                                    categories: data?.label || []
                                }
                            }}
                            series={[
                                {
                                    name: "Response",
                                    data: data?.series || []
                                }
                            ]}
                            type="bar"
                            width="500"
                        />
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card>
                        <Chart
                            options={{
                                chart: {
                                    id: "basic-bar"
                                },
                                xaxis: {
                                    categories: data?.label || []
                                }
                            }}
                            series={[
                                {
                                    name: "Response",
                                    data: data?.series || []
                                }
                            ]}
                            type="line"
                            width="500"
                        />
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card>
                        <Chart options={{labels: ['Response', 'Comments']}} series={data?.barChart || []} type="donut"
                               width="450"/>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}